import React from 'react';
import styles from './LiveUnloadPlannerCard.module.css';
import { Icons } from '@/assets';
import { ReactSVG } from 'react-svg';
import {
  handleCopyableIconClick,
  handleCopyableNameClick,
} from '@/utils/copyableFieldAction';

const CONTAINER_COPY_OPTIONS = { label: 'Container Number' };

export function PlannerCardKvColumn({ title, rows, trackingUrl }) {
  return (
    <div className={styles.kvColumnBox}>
      <h3 className={styles.colTitle}>{title}</h3>
      {(rows || []).map((row, i) => (
        <div key={`${row.label}-${i}`} className={styles.kv}>
          <span className={styles.kvLabel}>{row.label}</span>
          {row.label == 'Container' ? (
            <span className="flex items-center text-[#131517] font-bold">
              <span
                className="cursor-pointer hover:underline"
                role="button"
                tabIndex={0}
                onClick={(e) =>
                  handleCopyableNameClick(e, row.value, CONTAINER_COPY_OPTIONS)
                }
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleCopyableNameClick(e, row.value, CONTAINER_COPY_OPTIONS);
                  }
                }}>
                {row.value}
              </span>{' '}
              <span
                className="inline-flex cursor-pointer"
                role="button"
                tabIndex={0}
                onClick={(e) =>
                  handleCopyableIconClick(
                    e,
                    row.value,
                    trackingUrl,
                    CONTAINER_COPY_OPTIONS
                  )
                }
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleCopyableIconClick(
                      e,
                      row.value,
                      trackingUrl,
                      CONTAINER_COPY_OPTIONS
                    );
                  }
                }}>
                <ReactSVG
                  src={Icons.externalLink}
                  className={styles.linkIcon}
                />
              </span>
            </span>
          ) : (
            <span className={styles.kvValue}>{row.value}</span>
          )}
        </div>
      ))}
    </div>
  );
}
